// ----------------------------------------------------------------------- imports internos
import { mostrarNumero, whatsappDeChofer } from "../../shared/telefono";

/* El número de un chofer, tocable para escribirle por WhatsApp.
 *
 * QUÉ RESUELVE. Nico, 09/10, con el aviso del furgón 1552 de German Daniel
 * Silva: «en este reporte y en cualquiera que venga de parte de un chofer o
 * con un chofer, que aparezca el número del chofer clickeable». El aviso lo
 * manda a Pedidos de chóferes, y ahí el chofer era un nombre suelto: para
 * escribirle había que ir a buscar el número a otra pantalla.
 *
 * POR QUÉ ES UN COMPONENTE Y NO EL `Telefono` DE LA FICHA. Aquél tiene forma
 * de ficha (la etiqueta «Teléfono», las notas, el aviso de bloque vacío) y va
 * a buscar el número por DNI. Acá el número ya viene en la fila —es el
 * WhatsApp desde el que el chofer escribió, el dato más confiable que hay
 * porque es el chat real— y lo que hace falta es una celda. Las pantallas que
 * lo usan (pedidos, Mis pendientes, el espejo, la ticketera) lo dibujan igual
 * porque es el mismo componente.
 *
 * LAS DOS PUERTAS (`whatsappDeChofer`, en `shared/telefono.js`):
 *   · sin `ver.telefono_chofer` no se dibuja nada —tampoco con los permisos
 *     todavía cargando—, porque es un dato personal de alguien que no está
 *     mirando;
 *   · con la llave, si el número no se entiende tampoco: un enlace mal armado
 *     abre el chat de un desconocido y el mensaje sale igual.
 * En los dos casos devuelve `sin` (por defecto nada): la pantalla decide si
 * en lugar del enlace va el texto de siempre o un hueco.
 *
 * Abre en otra pestaña porque el hub puede estar adentro de un iframe: sin
 * `_blank`, WhatsApp Web intenta cargarse ahí adentro y parece que se rompió
 * la pantalla. Y va por `api.whatsapp.com/send`, como todo el sistema
 * (Igna, 14/10/2026; ver `aWhatsapp` en shared/telefono.js).
 *
 * Props:
 *   numero    el teléfono tal como esté escrito (lo normaliza `telefono.js`)
 *   permisos  los del contexto del Outlet; `null` = todavía no se sabe = cerrado
 *   nombre    del chofer, para el título y el aria-label («Escribirle a …»)
 *   etiqueta  texto opcional antes del enlace («chofer:»), sólo si hay enlace
 *   children  el texto del enlace; por defecto el número legible (+54 9 …)
 *   sin       qué dibujar cuando no hay enlace (por defecto, nada)
 */
const WhatsappChofer = ({ numero, permisos, nombre, etiqueta, children, sin = null }) => {
  const url = whatsappDeChofer(numero, permisos);
  if (!url) return sin;

  const quien = String(nombre ?? "").trim() || "este chofer";

  return (
    <span className="wa-chofer">
      {etiqueta && <span className="tenue">{etiqueta} </span>}
      <a
        className="dato doc-wa"
        href={url}
        target="_blank"
        rel="noreferrer"
        title={`Escribirle por WhatsApp a ${quien}`}
        aria-label={`Escribirle por WhatsApp a ${quien}`}
      >
        {children ?? mostrarNumero(numero)}
      </a>
    </span>
  );
};

export default WhatsappChofer;
